import request from '../requests/request'
import { setRecoil } from 'recoil-nexus'
import { branchState, districtState, provinceState, wardsState } from '../recoil/landingPageState'
import { accessTokenState } from '../recoil/authenticationState'
import { PRODUCT_TYPE } from '../constant'

const accountStore = {
  getBeautifulList: (params) => {
    return new Promise((resolve, reject) => {
      const url = '/accounts'
      request.post(url, params, false, false)
        .then(res => {
          if (res?.statusCode == '200') {
            resolve(res)
            setRecoil(accessTokenState, res?.sign)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  checkLegalId: (params) => {
    return new Promise((resolve, reject) => {
      const url = '/accounts/check'
      request.post(url, params, false, false)
        .then(res => {
          if (res?.statusCode == '200') {
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  onHoldAccount: (params) => {
    return new Promise((resolve, reject) => {
      const url = '/accounts/on-hold'
      request.post(url, params, false, false)
        .then(res => {
          if (res?.statusCode == '200') {
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  unHoldAccount: (params) => {
    return new Promise((resolve, reject) => {
      const url = `/accounts/on-hold-accounts/${params?.id}?businessNumber=${params?.businessNumber}`
      // request.delete(url, { legalId: params?.legalId, status: params.status }, false, false)
      request.delete(url, null, false, false)
        .then(res => {
          if (res?.statusCode == '200') {
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  sendOtp: (params) => {
    params.productType = PRODUCT_TYPE
    return new Promise((resolve, reject) => {
      const url = '/customer/login'
      request.post(url, params, false, false)
        .then(res => {
          if (res?.statusCode == '200') {
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  resendOtp: (params) => {
    params.productType = PRODUCT_TYPE
    return new Promise((resolve, reject) => {
      const url = '/customer/resend-otp'
      request.post(url, params, false, false)
        .then(res => {
          if (res?.statusCode == '200') {
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  verifyOtp: (params) => {
    params.productType = PRODUCT_TYPE
    return new Promise((resolve, reject) => {
      const url = '/customer/verify-otp'
      request.post(url, params, false, false)
        .then(res => {
          if (res?.statusCode == '200') {
            setRecoil(accessTokenState, res?.sign)
            resolve(res)
          }
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getProvince: () => {
    return new Promise((resolve, reject) => {
      const url = '/catalog/province'
      request.get(url, null, false, false)
        .then(res => {
          if (res) {
            setRecoil(provinceState, res?.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDistrict: (provinceId) => {
    return new Promise((resolve, reject) => {
      const url = `/catalog/district`
      request.get(url, { provinceId: provinceId }, false, false)
        .then(res => {
          if (res) {
            setRecoil(districtState, res?.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getWard: (districtId) => {
    return new Promise((resolve, reject) => {
      const url = `/catalog/ward`
      request.get(url, { districtId: districtId }, false, false)
        .then(res => {
          if (res) {
            setRecoil(wardsState, res?.data)
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getBranch: (provinceId) => {
    return new Promise((resolve, reject) => {

      const url = `/catalog/branch/all`
      request.get(url, { provinceId: provinceId, status: 'ACTIVE' }, true, false)
        .then(res => {
          if (res) {
            if (res?.data?.length > 0) {
              setRecoil(branchState, res?.data)
            }
          }
          resolve(res)
        })
        .catch(error => {
          reject(error)
        })
    })
  },


}
export default accountStore